export class AppFlags {
    IsMihAreaComplete: boolean = false;
    IsConstructionComplete: boolean = false;
    IsPILComplete: boolean = false;
    IsInfoSectionComplete: boolean = false;
    hasDevTeamMember: boolean = false;
    PILValue: string = '';
}

export class BuildingFlags {
    showDisclaimer: boolean = false; 
    buildingQuestionsComplete: boolean = false; 
    showMissingBuildingSection: boolean = false;
    missingBuildingSectionHeader: string = ''; 
    missingBuildingSectionDescription: string = ''; 
}

export class Entity {
    projectId: number = 0;
    entityId: number;
    partyId: number;
    partyAddressId: number;
    isStageEntry: boolean;
    isAddressStageEntry: boolean;
    entityRole: number;
    isOwner: boolean = false;
    organization: string;
    tin: string;
    tinType: number;
    address1: string;
    address2: string;
    city: string;
    state: number = 33;
    zipCode: string;
    phone: string;
    fax: string; 
    dbApplicationId: number = 84; //MIH default
    suppressCheck: boolean;
}

export class Contact {
    projectId: number;
    entityId: number;
    companyId: number; 
    projectDevTeamContactId: number;
    isStageEntry: boolean; 
    partyId: number; 
    commContactId: number; 
    comContactTelconId: number;
    partyAddressId: number;        
    fName: string ='';
    lName: string;    
    email: string;
    companyPhone: string;
    phoneExt: string;
    primaryContact: string; 
    dbApplicationId: number = 84; 
    isValid: boolean = false;
}


export class EntityParam {
    projectId: number;
    entityId: number;
    //projectDevTeamContactId: number;
    partyId: number;
    partyStagingId: number;
    partyAddressId: number; 
    partyAddressStagingId: number; 
    isStageEntry: boolean;
    commContactId: number;
    companyName: string; 
    tin: string;
    roleId: number; 
    partyRoleName: string;
    fName: string = '';
    lName: string;
    primaryContact: string;
    email: string;
    companyPhone: string;
    phoneExt: string;
    TINVerfiedFlag: boolean;    
    dbApplicationId: number = 84;
    newEntityEntry: string = ''; 
    isValid: boolean = false;

}

export class SaveEntityContact {
    contact: Contact;
    entityParamForContact: EntityParamForContact;
}

export class EntityParamForContact {
    projectId: number;
    entityId: number;
    partyId: number;
    partyStagingId: number;    
    companyName: string;
    tin: string;
    roleId: number;
    partyRoleName: string;
    newEntityEntry: string = '';
    dbApplicationId: number; 
}

export class EntityAdded {
    IsStageEntry: boolean;
    PartyAddressSeqNo: number; 
    PartySeqNo: number;
    MIHProjectDevTeamID: number; 
    MIHProjectBldgDevTeamID: number; 
}

export class SiteEntity {
    projectId: number = 0;
    ProjectBldgDevTeamID: number = 0;   // entityId: number;
    ProjectBuildingID: number = 0;      // ProjectBuildingID  --siteBuildingId
    BuildingID: number = 0;
    partyId: number;
    partyAddressId: number;
    isStageEntry: boolean;
    isAddressStageEntry: boolean;
    entityRole: number;
    isOwner: boolean = false;
    organization: string;
    tin: string;
    tinType: number;
    address1: string;
    address2: string;
    city: string;
    state: number = 33;
    zipCode: string;
    phone: string;
    fax: string;
    dbApplicationId: number = 84; //MIH default
    mood: string = '';
}

export class SiteEntityParam {
    projectId: number; 
    projectBldgDevTeamId: number;   //siteEntityId 
    //devProjectBuildingId: number;      //ProjectBuildingID
    siteProjectBuildingId: number;   //SiteProjectBuildingId
    bldgId: number;
    partyId: number;
    partyStagingId: number;
    partyAddressId: number;
    partyAddressStagingId: number;
    isStageEntry: boolean;
    entityRole: number;
    companyName: string;
    tin: string;
    siteAddress: string = ''; 
    partyRoleName: string;
    partyRoleSeqNo: number;
    TINVerfiedFlag: boolean;    
    dbApplicationId: number = 84;
    isValid: boolean = false;
    mood: string = '';
    newEntityEntry: string = ''; 
}

export class SaveSiteEntityContact {
    contact: SiteContact;
    siteEntityParam: SiteEntityParam
}

export class BuildingQuestionParam {
    projectId: number;    
    devProjectBuildingId: number;     //DevProjectBuildingID
    siteProjectBuildingId: number;    //SiteProjectBuildingID
    bldgId: number;                     //BldgID
    buildingTypeId: number;
    buildingAddress: string = '';
    mood: string = '';
}

// fields are define by MIHSiteEntityContact - MIHWebApi
export class SiteContact {
   
    projectBldgDevTeamContactId: number = 0;  //site entity contactId
    ProjectBldgDevTeamID: number = 0;   // site entityId
    projectId: number;
    ProjectBuildingID: number = 0;      // Project site buildingId
    BuildingID: number = 0;             // site building id
    isStageEntry: boolean;
    partyId: number;
    commContactId: number;
    comContactTelconId: number;    
    fName: string = '';
    lName: string;
    primaryContact: string;
    email: string;
    companyPhone: string;
    phoneExt: string;    
    partyAddressId: number;
    dbApplicationId: number = 84;
    isValid: boolean = false;
    //companyId: number;
    //projectDevTeamContactId: number;
}

export class SiteContactParam {
    
    projectBldgDevTeamContactId: number = 0;  //site entity contactId
    ProjectBldgDevTeamID: number = 0;
    projectId: number;
    ProjectBuildingID: number = 0;
    BuildingID: number = 0;

    //projectDevTeamContactId: number;
    isStageEntry: boolean;
    partyId: number;
    partyStagingId: number;
    partyAddressId: number;
    partyAddressStagingId: number;
    isAddressStageEntry: boolean;
    commContactId: number;
    comContactTelconId: number;
    companyName: string;
    siteAddress: string = '';
    partyRoleName: string = '';
    roleId: number = 0;
    fName: string = '';
    lName: string;
    primaryContact: string;
    email: string;
    companyPhone: string;
    phoneExt: string;
    TINVerfiedFlag: boolean;
    dbApplicationId: number = 84;
    isValid: boolean = false;
}

export class EntityContactParam {
    projectId: number;
    projectBldgDevTeamContactId: number = 0;  //site entity contactId
    ProjectBldgDevTeamID: number = 0;   
    ProjectBuildingID: number = 0;      
    BuildingID: number = 0;
    entityId: number;
    projectDevTeamContactId: number;
    partyId: number;
    partyStagingId: number;
    isStageEntry: boolean;
    partyAddressId: number;
    partyAddressStagingId: number;
    isAddressStageEntry: boolean;
    commContactId: number;
    comContactTelconId: number;
    companyName: string;
    siteAddress: string = ''; 
    partyRoleName: string ='';
    roleId: number = 0; 
    fName: string = '';
    lName: string;
    primaryContact: string;
    email: string;
    companyPhone: string;
    phoneExt: string;
    TINVerfiedFlag: boolean;
    dbApplicationId: number = 84;
    isValid: boolean = false;
}

export class SiteEntityContactParam {
    
    projectBldgDevTeamContactId: number = 0;  //site entity contactId
    ProjectBldgDevTeamID: number = 0;
    projectId: number;
    ProjectBuildingID: number = 0;
    siteProjectBuildingID: number = 0; 
    BuildingID: number = 0;
    //entityId: number;
    //projectDevTeamContactId: number;
    isStageEntry: boolean;
    partyId: number;
    partyStagingId: number;    
    partyAddressId: number;
    partyAddressStagingId: number;
    isAddressStageEntry: boolean;

    commContactId: number;
    comContactTelconId: number;    
    fName: string = '';
    lName: string;
    primaryContact: string;
    email: string;
    companyPhone: string;
    phoneExt: string;
    TINVerfiedFlag: boolean;

    companyName: string;
    siteAddress: string = '';
    partyRoleName: string = '';
    roleId: number = 0;

    dbApplicationId: number = 84;
    isValid: boolean = false;
}

export class DeleteEntity { 
	projectId: number;
    entityId: number;   
    companyName: string; 
    roleId: number = 0;
}

export class Account {
    firstName: string; 
    lastName: string; 
    fullName: string;
    email: string;
    organization: string;
    phone: string;

}  

export class MIHArea {
    ProjectId: number = 0;
    MIHId: number = 0;
    ZoningId: number = 0;
    BsaId: number = 0;
    PrivateRezoningId: number = 0; 
    PrivateRezoning: string; 
    ZoningResolutionMap: string;
    BSASpecialPermit: string;
    Description: string;
    IsValid: boolean = false;
}

export class Construction {
    ProjectId: number = 0;
    NewConstructionId: number = 0; 
    ConversionId: number = 0;
    EnlargementId: number = 0; 
    NewConstruction: boolean;    
    Conversion: boolean;    
    Enlargement: boolean;
    IsValid: boolean = false;
}

export class HousingFund {
    ProjectId: number = 0;
    HfoId: number = 0;
    Hfo: string;
    IsValid: boolean = false;
}

export class Financing {
    ProjectId: number = 0;
    FinanceId: number = 0;
    Financed: string; 
    FinanceTypeCity: string; 
    FinanceTypeState: string;
    FinanceTypeFederal: string;
    FinanceCityHpd: string;
    FinanceCityHdc: string;
    FinanceCityOther: string;
    IsValid: boolean = false; 
}

export class TaxExemption {
    ProjectId: number = 0;
    TaxExemptionId: number = 0;
    TaxEExemptionSeqNo: number = 0;
    TaxExemptionName: string = '';
    TaxSource: string = ''; 
}

export class AddAppName {
    AppName: string = '';
    ProjectId: number = 0;
}



export class UnitCount {
    ProjectId: number;
    EntityId: number;
    //ProjectBuildingId: number;
    DevProjectBuildingId: number; 
    SiteProjectBuildingId: number;
    BuildingId: number; 
    FloorAreaTrackingId 
    Floorarea: number;
    UnitCount: number; 
    IsValid: boolean = false;
}

export class BuildingType {
    ProjectId: number = 0;
    EntityId: number = 0;
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;
    IsDev: boolean; 
    IsDevBuilding: string; 
    IsValid: boolean = false;
}

export class Funding {
    ProjectId: number = 0;
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number; 
    FundingTrackingId: number = 0;

    HasPublicFunding: string;
    HasCitySourceCategory: boolean;
    HasStateSourceCategory: boolean;
    HasFederalSourceCategory: boolean;
    HasHPDCitySubsidy: boolean;
    HasHDCCitySubsidy: boolean;
    HasOtherCitySubsidy: boolean;
    OtherCitySubsidySourceName: string=''; 
    IsValid: boolean = false;
}

export class TaxCredit {
    ProjectId: number = 0;
    //ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number; 

    IsRequestingTaxCredits: string = '';
    HasLIHTC4PercTaxCreditType: boolean;
    HasLIHTC9PercTaxCreditType: boolean;
    HasBrownFieldsTaxCreditType: boolean;
    HasHistoricTaxCreditType: boolean;
    HasSLIHCTaxCreditType: boolean;
    HasNewMarketsTaxCreditType: boolean;
    HasOtherTaxCreditType: boolean;
    OtherTaxCreditTypeName: string = '';

    SourceCitySubsidy: string='';
    //HasHDCCitySubsidy: boolean;
    IsValid: boolean = false;
}

export class TaxIncentive {
    ProjectId: number = 0;
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number; 
    IsRequestingTaxIncentives: string = '';     
    TaxIncentives = []; 
    dropdownList = [];
    selectedItems = [];
    IsValid: boolean = false; 
}

export class Incentives {
    id: number; 
    itemName: string = '';
    lookupTrackingId: number;
    lookupTrackingValue: string;
}

export class SiteUnitCount {
    ProjectId: number;
    EntityId: number;
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;
    SiteUnitCountId: number;
    MihUnits: number;
    MIHFloorArea: number;
    SuperUnits: number;
    IsValid: boolean = false;
}

export class CondoStructure {
    ProjectId: number = 0;
    EntityId: number;
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;
    CondoStructure: string;
    Description: string;
    IsValid: boolean = false;
}

export class ElectricSystems {
    ProjectId: number = 0; 
    EntityId: number = 0; 
    ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;

    HasElectricSystems: string; 
    HasPTCASHeatPumps: boolean; 
    HasPoweredBoilers: boolean; 
    HasElectricStoves: boolean; 
    IsValid: boolean = false;
}

export class MihOptions {
    ProjectId: number = 0;
    //ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;
    MihOptionId: number = 0;
    MihOption: string; 
    IsValid: boolean = false;

}

export class MihUnits {
    ProjectId: number = 0;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    //ProjectBuildingId: number;
    BuildingId: number;
    MihUnitId: number = 0;
    IsDevSite: string;
    IsValid: boolean = false;

}


export class LocationMihSiteUnit {
    ProjectId: number = 0;
    //ProjectBuildingId: number;
    DevProjectBuildingId: number;
    SiteProjectBuildingId: number;
    BuildingId: number;
    LocationMihSiteUnitId: number = 0;
    MihSiteLocation: string;
    Editable: boolean = true; 
    IsValid: boolean = false;
}

export class MIHSiteEntityAssociations {
    projectId: number = 0;
    siteProjBuildingId: number = 0;
    bldgId: number = 0;
    ProjDevTeamIds: Array<number>;
}


//export class MIHDevSiteAssociations {
export class DevSiteAssociations {
    projectId: number = 0;
    devProjBuildingId: number = 0;
    devBldgId: number = 0; 
    siteBldgs: Array<siteBldg>;
}

export class siteBldg {
    siteProjBuildingId: number = 0; 
    siteBldgId: number = 0; 
}

/*
export class DevTeamEntitySelect {
    projectId: number = 0;
    siteProjBuildingId: number = 0; 
    bldgId: number =0; 
    projDevTeamIds: Array<number>;
} */

export class CheckList {
    ProjectId: number = 0;
    InfoSectionComplete: boolean = false;
    DevTeamMembersComplete: boolean = false; 
    
    HasBuilding: boolean = false; 
    BuildingAssociationComplete: boolean = false;
    BuildingQuestionsComplete: boolean = false; 
    SiteTeamMemberComplete: boolean = false; 
    Disclaimer: boolean = false; 
    PilValue: string = '';
    PilAlertMessageId: number = 0;
    PilAlertMessage: string = '';   
    AllRequireEntryComplete: boolean = false; 
}

export class PartyAddress { 

    PartyAddressID: number = 0; 
    AddressLine1: string = '';
    AddressLine2: string = ''; 
    City: string = '';
    State: string = '';
    PostalCode: string = '';
    StateLookup: StateLookup; 
    CorporateEmail: string = '';
    CorporatePhoneNumber: string = '';
    CorporateFax: string = '';

    }

    export class StateLookup {
    GroupName: string = "State";
    LongName: string = "NEW YORK";
    ShortName: string = "NY";
    SeqNo: number = 33;
}

export class AddBuildingForm {
    ProjectId: number = 0; 
    Boro: string = '';
    Block: number;
    Lot: number; 
    PHN: string = ''; 
    StreetName: string = ''; 
    NewStreetName: string = ''; 

    }

export class MaintenanceNotification {
    MaintenanceMessage: string;
    DisplayMsgStartTime: string;
    MaintenanceStartTime: string;
    MaintenanceEndTime: string; 
     
}

export class SummaryInstruction {
    appSummaryText: string;
    devTeamText: string; 
    siteTeamText: string;
    associationText: string;
}

export class AppModeUpdateModel
{
    ProjectId: number;
    Mode: AppMode;
}

export enum AppMode
{
    Edit,
    Complete
}

export class MIHDocumentType {
    ProjectID: number;
    DropDownSortSeq: number;
    DropDownText: string;
    DocumentType: number;
    BldgID: number;
    PartyID: number;
    PartyStagingID: number;
}

export class MIHSubDocumentType {
    ProjectID: number;
    DropDownSortSeq: number;
    DropDownText: string;
    DocumentSubType: number;
    DocumentRequired: string;
    DocumentType: number;
    BldgID: number;
    PartyID: number;
    PartyStagingID: number;
}

export class MIHUploadDocInfo {
    ProjectID: number;
    DocumentType: number;
    DocumentSubType: number;
    DocumentSubTypeName: string;  
    BldgID: number;
    PartyID: number;
    PartyStagingID: number;
    OtherDocType: string;  
}


export class MIHDocument {
    MIHDocumentID: number;
    DocumentID: number;
    DocumentTypeID: number;
    DocumentType: string;
    SubDocumentTypeID: number;
    SubDocumentType: string;
    DocumentName: string;
    UploadedDate: Date;
    GroupSequence: number;
    IsFirstRecordInGroup: boolean;
}